import React, { useEffect } from "react";
import Layout from "../../Layout";
import HeaderOrg from "../HeaderOrg";
import UploadOrgForm from "./UploadOrgForm";

const UploadOrg = () => {
    useEffect(() => {
        const heading = document.querySelector("h1.form-title");
        if (heading) {
            heading.setAttribute("tabindex", "-1");
            heading.focus();
        }
    }, []);

    return (
    <Layout>
        <HeaderOrg />
        <main className="layout-container">
            <div
                className="container"
                tabIndex="-1"
            >
                <h1 className="form-title g-clr">Upload Organizations</h1>
                <p className="descript-container">
                    The data in the CSV file prepared for upload must not contain any
                    commas, as CSV format uses commas as field separators. Any comma
                    within a field will disrupt the formatting. The first line in the file
                    is a fixed header containing field names, as shown in the screenshot
                    of the sample file below. This header line is also included in the CSV
                    template. Please ensure you save your upload file in CSV
                    (comma-separated values) format.
                </p>
                <UploadOrgForm />
            </div>
        </main>
        </Layout>
    )
};


export default UploadOrg;
